import { Role, User } from "parse";
import React, { useEffect } from "react";
import { fetchAllRolesWithSubordinates } from "../functions/fetchAllRolesWithSubordinates";

/**
 * Returns all roles of the user and their subordinate roles
 * @param user
 * @returns array of roles
 */
export const useSubordinateRoles = (user: User) => {
  const [roles, setRoles] = React.useState<Role[]>([]);
  useEffect(() => {
    fetchAllRolesWithSubordinates(user).then((roles) => setRoles(roles));
  }, [user]);

  return roles;
};
